var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("entity-list", {
    attrs: {
      entity: "rumour",
      "use-events": true,
      "entity-headers": _vm.headers,
      "events-values": _vm.rumourEvents,
      "event-id": _vm.eventId,
      "team-id": _vm.teamId
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }